<template>
  <div
    class="br-subleft overflow-y-auto"
    :data-min="sideStatus"
    style="z-index: 1"
  >
    <div>
      <h6
        class="
          tx-uppercase tx-10 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("subuser.子账号筛选") }}
      </h6>
      <div class="mg-t-20 pd-x-10 mg-b-40">
        <div class="mg-b-20 form-group">
          <input
            type="text"
            v-model="name"
            :placeholder="$t('subuser.姓名')"
            @keyup.enter="filtrate"
            class="form-control form-control-dark tx-14"
          />
        </div>
        <div class="form-group">
          <select
            class="form-control form-control-dark select2 mg-b-10"
            @change="filtrate"
            v-model="status"
          >
            <option value="">{{ $t("express.选择状态") }}</option>
            <option value="1">{{ $t("express.启用") }}</option>
            <option value="2">{{ $t("express.停用") }}</option>
          </select>
        </div>
        <button
          class="
            btn btn-primary btn-block
            tx-uppercase tx-11 tx-spacing-2 tx-medium
          "
          @click="filtrate"
        >
          {{ $t("subuser.筛 选") }}
        </button>
      </div>
    </div>
    <div>
      <h6
        v-if="isSysRights('UserRole.findByUserId')"
        class="
          tx-uppercase tx-10 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("subuser.角色组") }}
      </h6>
      <nav
        v-if="isSysRights('UserRole.findByUserId')"
        class="nav br-nav-mailbox flex-column nav-role"
      >
        <div
          class="group-name-wrap"
          v-for="item in list"
          :key="item.id"
          :class="{ active: item.id == keyRoleId }"
        >
          <a
            @click="filterRole(item.id, item.name)"
            href="javascript:;"
            class="nav-link"
          >
            <i class="icon ion-person-stalker tx-16-force"></i>{{ item.name }}
          </a>
          <a
            v-if="isSysRights('UserRole.changeUserRole')"
            @click="editNew(item)"
            href="javascript:;"
            class="edit"
            ><i class="icon ion-edit tx-16-force"></i
          ></a>
          <a
            v-if="isSysRights('UserRole.delUserRole')"
            @click="del(item.id, item.name)"
            href="javascript:;"
            class="del"
            ><i class="icon ion-android-delete tx-16-force"></i
          ></a>
        </div>
      </nav>
    </div>
    <div class="text-center mg-t-15">
      <a
        v-if="isSysRights('UserRole.changeUserRole')"
        href="javascript:;"
        @click="editNew('')"
        class="btn btn-success"
        >{{ $t("subuser.新建角色") }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sideStatus: Boolean,
    keyName: String,
    keyStatus: [String, Number],
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    keyRoleId: [Number, String],
  },
  data() {
    return {
      name: "",
      status: "",
    };
  },
  watch: {
    keyName() {
      this.name = this.keyName;
    },
    keyStatus() {
      this.status = this.keyStatus;
    },
  },
  mounted() {
    $(".overflow-y-auto").perfectScrollbar();
  },
  methods: {
    // 选择角色
    filterRole(id, name) {
      if (this.$parent.filterProp.keyRoleId == id) {
        this.$parent.filterProp.keyRoleId =
          this.$parent.filterProp.keyRoleName = "";
      } else {
        this.$parent.filterProp.keyRoleId = id;
        this.$parent.filterProp.keyRoleName = name;
      }
      this.filtrate();
    },
    // 新建或编辑角色
    editNew(item) {
      this.$parent.roleinfo = {
        open: new Date().getTime(),
        info: item,
      };
      $("#modalSubUserGroupNew").modal("show");
    },
    // 删除角色
    del(id, name) {
      this.$parent.roleinfo = {
        id,
        name,
      };
      $("#modalDelSubUserGroup").modal("show");
    },
    // 搜索
    filtrate() {
      this.$parent.filterProp.keyName = this.name;
      this.$parent.filterProp.keyStatus = this.status;
      this.$parent.getSubuserList();
    },
  },
};
</script>